import { AnimatePresence } from 'framer-motion';
import React from 'react';
import PropTypes from 'prop-types';
import { AnimationVariants, MainContent } from './styles/PageAnimationStyled';

const PageAnimation = ({ children }) => {
  return (
    <AnimatePresence>
      <MainContent
        variants={AnimationVariants}
        initial="initial"
        animate="enter"
        exit="exit"
      >
        {children}
      </MainContent>
    </AnimatePresence>
  );
};

PageAnimation.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default PageAnimation;
